import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import { TextInput } from '@telus-uds/components-web';

const Xid = ({ fieldData, setFieldData, formErrors, setFormErrors }) => {
  useEffect(() => {
    return () => {
      setFieldData(previousValue => ({ ...previousValue, xid: '' }));
    };
  }, []);

  return (
    <TextInput
      label={
        <>
          XID/TID *
          <div style={{ fontSize: '12px', color: '#666' }}>
            Note: Enter your full TELUS ID starting with X or T (e.g., T123456)
          </div>
        </>
      }
      type="tel"
      pattern="[0-9a-zA-Z]{7,8}"
      maxLength="8"
      value={fieldData.xid}
      validation={'xid' in formErrors ? 'error' : undefined}
      feedback={'xid' in formErrors ? formErrors.xid.message : undefined}
      onChange={(value) => {
        if (!value)
          setFormErrors({
            ...formErrors,
            xid: { message: 'Field is required' }
          });
        else if (!/^[0-9a-zA-Z]{7,8}$/.test(value)) {
          setFormErrors({
            ...formErrors,
            xid: {
              message: 'Must be a minimum of 7 and maximum of 8 characters'
            }
          });
        } else {
          const errors = { ...formErrors };
          delete errors.xid;
          setFormErrors({
            ...errors
          });
        }
        setFieldData(previousValue => ({
          ...previousValue,
          xid: value
        }));
      }}
    />
  );
};

Xid.propTypes = {
  formErrors: PropTypes.shape({
    xid: PropTypes.shape({
      message: PropTypes.string
    })
  }).isRequired,
  setFormErrors: PropTypes.func.isRequired,
  setFieldData: PropTypes.func.isRequired,
  fieldData: PropTypes.shape({
    role: PropTypes.number,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    contactNumber: PropTypes.string,
    provinces: PropTypes.arrayOf(PropTypes.string),
    channels: PropTypes.arrayOf(PropTypes.string),
    outlet: PropTypes.string,
    cpmsId: PropTypes.string,
    xid: PropTypes.string,
    storeCode: PropTypes.string,
    dealership: PropTypes.arrayOf(PropTypes.string),
    channelOrgCode: PropTypes.string,
    salesManager: PropTypes.string,
    salesManagerEmail: PropTypes.string
  }).isRequired
};

export default Xid;
